<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap class="ma-0" v-scroll="onScroll">

      <v-toolbar class="pa-0 ma-0 extension-padding" fixed flat
                 extension-height="40px">
        <v-btn icon class="mr-0" @click="goBack">
          <v-icon size="32px" color="#a9a9af">$vuetify.icons.navArrowLeft</v-icon>
        </v-btn>
        <!--        <div class="channel-small-icon mr-2">채널</div>-->
        <h3 class="display-2 text-truncate">{{ productTitle }}</h3>
        <!--        <v-spacer></v-spacer>-->
        <!--        <v-btn :ripple="false"-->
        <!--               icon-->
        <!--               depressed-->
        <!--               :dark="!product.channels.subscribes"-->
        <!--               :outline="product.channels.subscribes"-->
        <!--               :color="product.channels.subscribes ? null : 'primary'"-->
        <!--               class="top-button mr-0"-->
        <!--               @click="subscribe(product.channels.idx)">-->
        <!--          <v-icon size="10px"-->
        <!--                  :color="product.channels.subscribes ? 'primary' : null"-->
        <!--                  :dark="!product.channels.subscribes">-->
        <!--            {{ product.channels.subscribes ? '$vuetify.icons.confirm' : '$vuetify.icons.add' }}-->
        <!--          </v-icon>-->
        <!--        </v-btn>-->
        <template v-slot:extension v-if="isScroll">
          <v-tabs v-model="activeTab" slider-color="#4a4a4a" mandatory color="#f8f8f8">
            <v-layout row>
              <v-flex xs4>
                <v-tab :ripple="false" href="#Introduce" class="tab" @click="$vuetify.goTo('#Introduce', tabScrollOptions)">소개</v-tab>
              </v-flex>
              <v-flex xs4>
                <v-tab :ripple="false" href="#Preview" class="tab" @click="$vuetify.goTo('#Preview', tabScrollOptions)">미리보기</v-tab>
              </v-flex>
              <v-flex xs4>
                <v-tab :ripple="false" href="#Talk" class="tab" @click="$vuetify.goTo('#Talk', tabScrollOptions)">Let's Talk</v-tab>
              </v-flex>
            </v-layout>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-flex xs12 v-if="loading">
        <v-progress-circular indeterminate style="margin: auto; margin-top: 100px;"></v-progress-circular>
      </v-flex>

      <v-flex xs12 style="padding-top: 56px" v-show="!loading">
        <v-card tile flat class="text-xs-left" ref="introHeader">
          <v-img :src="thumbnailSrc"
                 :aspect-ratio="16/9"
                 lazy-src="@/assets/img/thumbnail-default.png"
                 @error="isImageLoaded = false">
            <VideoPlayer ref="videoWrapper"
                         v-if="product.preview && product.preview.endsWith('.mp4')"
                         class="vjs-custom-player"
                         :options="playerOptions"
                         :playsinline="true"
                         @ready="onPlayerReady"
                         @loadeddata="onLoaded"
                         @ended="onEnded"
                         @error="onError" />
            <iframe v-else-if="product.preview && product.preview.endsWith('.youtube')"
                    id="player" type="text/html"
                    width="100%" height="100%"
                    :src="`https://www.youtube.com/embed/${product.preview.split('.')[0]}?enablejsapi=1&origin=${origin}&playsinline=1&modestbranding=1&rel=0`"
                    frameborder="0"></iframe>
          </v-img>
          <v-card-title class="mt-4 pt-0 mx-1 display-4">
            <div style="font-size: 24px; line-height: 32px; letter-spacing: -0.6px; color: #4a4a4a; width: 100%;">{{ product.title }}</div>
            <div v-if="product.subtitle" class="custom-chip mr-2">{{ product.subtitle }}</div>
            <div v-if="product.status === 'earlybird' && product.published_at" class="custom-chip">{{ new Date(product.published_at).getMonth() + 1 }}월 {{ new Date(product.published_at).getDate() }}일 런칭</div>
            <v-spacer></v-spacer>
            <v-btn icon class="my-0 pa-0" style="margin-left: auto; margin-right: -6px;" @click="share">
              <v-icon>$vuetify.icons.share</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pb-0 pt-4 px-4 mx-0 top-right-radius" style="background-color: #f8f8f8;">
            <v-layout column v-if="product.status === 'ready'">
              <div style="color: #222222; font-size: 24px; font-weight: 700;">신규 제작 예정</div>
              <div style="font-size: 12px; font-weight: 700; color: #707070;">이 스토리를 좀 더 빨리 만나보고 싶으시면 <v-icon size="16px">$vuetify.icons.heartOutlined</v-icon>를 눌러주세요!</div>
            </v-layout>
            <v-layout align-end v-else>
              <div>
                <div v-if="product.amount !== finalPrice" class="caption">
                  <span style="color: #ec2f54; font-weight: 700;" class="mr-1">{{ product.discount }}% 할인</span>
                  <span style="color: #9b9b9b; text-decoration: line-through;" class="mr-1">{{ addComma(product.amount) }}원</span>
                  <span style="color: #9b9b9b;" v-show="product.installment > 1">{{ addComma(finalPrice) }}원</span>
                </div>
                <div>
                  <span style="color: #222222; font-size: 24px; font-weight: 700;">{{ product.installment > 1 ? '월 ' : '' }}{{ addComma(Math.floor(finalPrice / product.installment)) }}원</span>
                  <span style="color: #222222; font-size: 14px; font-weight: 700; letter-spacing: -0.2px;" class="ml-1">{{ product.installment > 1 ? '부터' : '' }}</span>
                </div>
                <div v-if="product.installment > 1">
                  <span style="font-size: 12px; font-weight: 700; color: #9b9b9b;">최대 할인 적용 {{ product.installment }}개월 할부시</span>
                  <v-tooltip top transition="slide-y-reverse-transition">
                    <template v-slot:activator="{ on }">
                      <span class="d-inline-block installment-tooltip" v-on="on">?</span>
                    </template>
                    <v-card style="background-color: #4a4a4a; color: #9b9b9b; border-radius: 10px;" flat>
                      <v-card-text>
                        <div>무이자 할부 적용 금액: 5만원 이상</div>
                        <div>하나카드: 2~3개월  삼성카드: 2~6개월</div>
                        <div>현대카드: 2~6개월  비씨카드: 2~6개월</div>
                        <div>국민카드: 2~5개월  씨티카드: 2~6개월</div>
                        <div class="text-xs-left">신한카드: 2~6개월  NH카드: 2~6개월</div>
                      </v-card-text>
                    </v-card>
                  </v-tooltip>
                </div>
              </div>
              <v-spacer></v-spacer>
              <div style="display: flex; flex: 0 0 auto; align-items: center;">
                <v-img style="display: inline-flex;flex-grow: 0;" :src="require('@/assets/img/icon-star-active.png')" width="24px" height="24px"></v-img>
                <span class="caption" style="color: #ec2f54;">{{ product.review_avg.toFixed(1) }}</span>
              </div>
            </v-layout>
            <v-divider class="mt-4"></v-divider>
          </v-card-text>

          <v-card-text class="summary-text pb-5" style="position: relative; background-color: #f8f8f8;">
            <!--            <div class="summary-more-gradient"></div>-->
            <div>
              <p class="mb-0" style="white-space: pre-wrap;">{{ product.summary }}</p>
            </div>
            <!--            <v-layout align-center style="width: 100%; height: 40px;">-->
            <!--              <v-btn flat small-->
            <!--                     color="#4a4a4a"-->
            <!--                     class="mr-0 my-0 px-1"-->
            <!--                     style="margin-left: -4px; min-width: 0;">-->
            <!--                더보기-->
            <!--                <v-icon size="16px">$vuetify.icons.arrowDown</v-icon>-->
            <!--              </v-btn>-->
            <!--            </v-layout>-->
          </v-card-text>

          <v-card-text style="padding: 0 20px; background-color: #f8f8f8;" v-if="product.amount">
            <v-layout row style="height: 96px;">
              <v-layout column mr-1 class="align-center justify-center" style="flex-basis: 50%; background-color: white; border-radius: 5px;">
                <div style="font-size: 24px; font-weight: 700; line-height: 32px; color: #ec2f54; letter-spacing: -0.6px;">{{ product.installment }}개월</div>
                <div style="font-size: 14px; line-height: 24px; color: #707070; letter-spacing: -0.3px;">수강기간</div>
              </v-layout>
              <v-layout column ml-1 class="align-center justify-center" style="flex-basis: 50%; background-color: white; border-radius: 5px;">
                <div style="font-size: 24px; font-weight: 700; line-height: 32px; color: #ec2f54; letter-spacing: -0.6px;">{{ lectureCount }}개</div>
                <div style="font-size: 14px; line-height: 24px; color: #707070; letter-spacing: -0.3px;">전체 컨텐츠</div>
              </v-layout>
            </v-layout>
            <v-layout column align-center justify-center style="padding: 24px 0 40px; color: #4a4a4a; font-size: 14px; line-height: 20px; letter-spacing: -0.3px;">
              <span>이 클래스와 함께하는 유학준비로</span>
              <span style="font-weight: 700;">인생의 소중한 기회를 직접 만들어보세요.</span>
            </v-layout>
          </v-card-text>

        </v-card>
      </v-flex>

      <v-flex xs12 v-show="!loading">
        <v-tabs v-model="activeTab" slider-color="#4a4a4a" mandatory color="#f8f8f8">
          <v-layout row>
            <v-flex xs4>
              <v-tab :ripple="false" href="#Introduce" class="tab" @click="$vuetify.goTo('#Introduce', tabScrollOptions)">소개</v-tab>
            </v-flex>
            <v-flex xs4>
              <v-tab :ripple="false" href="#Preview" class="tab" @click="$vuetify.goTo('#Preview', tabScrollOptions)">미리보기</v-tab>
            </v-flex>
            <v-flex xs4>
              <v-tab :ripple="false" href="#Talk" class="tab" @click="$vuetify.goTo('#Talk', tabScrollOptions)">Let's Talk</v-tab>
            </v-flex>
          </v-layout>
        </v-tabs>
      </v-flex>

      <v-flex xs12 class="pa-0 ma-0" v-show="!loading">
        <v-card tile flat class="card-shadow">
          <!-- 소개: 패키지, 상품소개내용, 도움이될거에요 -->
          <v-container id="Introduce" class="justify-center pt-0 px-0 pb-5" v-if="product.packages">
            <v-layout column align-center class="pt-4">
              <span class="package-text-big pt-3 pb-3">패키지 구매시<br><span class="font-weight-bold">YOUTH 키트</span>가 제공됩니다.</span>
              <v-divider class="my-3" style="width: 29px;"></v-divider>
            </v-layout>

            <v-layout row justify-start align-center class="pt-3" style="width: 260px; margin: auto;">
              <v-img width="35px" height="35px" aspect-ratio="1" class="mr-4" style="flex-grow: 0;"
                     :src="require('@/assets/img/play-video.png')"></v-img>
              <span class="text-xs-left package-text"><span class="font-weight-bold">온라인 영상 강의</span>가 제공됩니다.<br>반복 수강이 가능합니다.<br><span style="font-size: 12px; color: #707070;">* 수강 기한은 6개월입니다.</span></span>
            </v-layout>

            <v-layout row justify-start align-center style="width: 260px; margin: auto;" class="mt-4 mb-4">
              <v-img width="35px" height="35px" aspect-ratio="1" class="mr-4" style="flex-grow: 0;"
                     :src="require('@/assets/img/kit-box.png')"></v-img>
              <span class="text-xs-left package-text"><span class="font-weight-bold">유학의 모든 것이 담긴 키트입니다.</span><br>핵심 유학 정보가 담긴 책자들과<br>예쁜 엽서까지!<br><span style="font-size: 12px; color: #707070;">* 현재는 국내배송만 가능합니다.</span></span>
            </v-layout>

            <v-layout class="pt-3">
              <v-expansion-panel class="expansion-panel-style">
                <v-expansion-panel-content expand-icon="$vuetify.icons.arrowDown">
                  <template v-slot:header>
                    <span class="mr-2 package-text" style="flex-grow: 0;">패키지 더보기</span>
                  </template>
                  <v-card class="pt-4"><div v-html="product.package_contents"></div></v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-layout>

          </v-container>

          <v-container class="pa-0">
            <v-layout column>
              <div class="product-style body-1" v-html="product.contents"></div>
              <!--              <div class="mt-5">-->
              <!--                <ChannelListTile :idx="product.channels.idx"-->
              <!--                                 :title="product.channels.title"-->
              <!--                                 :introduce="product.channels.introduce"-->
              <!--                                 :subscribeCnt="product.channels.subscribe_cnt"-->
              <!--                                 :thumbnail="product.channels.thumbnail"-->
              <!--                                 :subscribes="product.channels.subscribes"-->
              <!--                                 @subscribe="subscribe(product.channels.idx)" />-->
              <!--              </div>-->
            </v-layout>
          </v-container>

          <!-- 커리큘럼 -->
          <v-container class="pa-0 text-xs-left mt-5" v-if="product.chapters.length">
            <div class="px-3" id="Preview">
              <h2 style="padding-bottom: 32px; font-size: 24px; font-weight: 700; line-height: normal; letter-spacing: -0.3px; text-align: left; color: #4a4a4a;">커리큘럼</h2>
              <p style="color: #4a4a4a; font-size: 14px; line-height: 20px; letter-spacing: -0.3px;">스토리를 통하여 수강하실 수 있는 내용입니다.<br>일부는 무료로 제공됩니다.</p>
            </div>

            <v-list v-for="(chapter, index) in product.chapters" :key="index">
              <v-subheader class="px-3 chapter-text">
                <span>{{ chapter.number !== 0 ? `Chapter ${chapter.number} : ` : '' }}{{ chapter.title }}</span>
              </v-subheader>

              <v-list-tile v-for="lecture in chapter.lectures" :key="lecture.idx" class="pa-0 list-padding"
                           @click="playLecture(lecture.status, lecture.idx)"
                           style="background-color: #f8f8f8;">
                <v-layout align-center style="margin-top: 6px; margin-bottom: 6px;">
                  <span class="lecture-title">{{ lecture.title }}</span>
                  <span v-if="lecture.status === 'free'" class="ml-1"
                        style="text-transform: uppercase; font-size: 10px; color: #ec2f54; font-weight: 700;">
                    free
                  </span>
                  <v-spacer></v-spacer>
                  <v-btn icon size="16px" class="ma-0">
                    <v-img v-if="lecture.status === 'free' || product.purchases" style="flex-grow: 0;"
                           :src="require('@/assets/img/icon-play-active.png')"
                           width="16px" height="16px"></v-img>
                    <v-img v-else style="flex-grow: 0;"
                           :src="require('@/assets/img/icon-play-deactive.png')"
                           width="16px" height="16px"></v-img>
                  </v-btn>
                </v-layout>
              </v-list-tile>
            </v-list>
          </v-container>

          <!-- 리뷰 -->
          <v-container class="pa-0 text-xs-left mt-5" v-if="product.reviews.length">
            <div class="px-3 pb-4">
              <h2 class="d-inline-block mr-2">리뷰</h2>
              <!--              <span>{{ product.review_cnt }}개의 글</span>-->
            </div>
            <v-card tile flat class="pa-0 ma-0">
              <v-list class="pa-0 px-3">
                <ReviewListTile v-for="(review, index) of product.reviews" :key="index"
                                :idx="review.idx"
                                :createdAt="review.created_at"
                                :updatedAt="review.updated_at"
                                :contents="review.contents"
                                :user="review.user"
                                :reviewScore="review.review_score" />
                <!--                <v-btn block round outline @click="$router.push({ name: 'ReadProductReviews', params: { idx } })">리뷰 더보기</v-btn>-->
              </v-list>
            </v-card>
          </v-container>

          <!-- 렛츠톡 -->
          <v-container id="Talk" class="pa-0 text-xs-left mt-5">
            <span ref="talkListTiles"></span>
            <div class="px-3 pb-1">
              <h2 class="d-inline-block mr-2" style="padding-bottom: 32px; font-size: 24px; font-weight: 700; line-height: normal; letter-spacing: -0.3px; text-align: left; color: #4a4a4a;">Let's Talk</h2>
              <span v-show="product.talk_cnt"
                    style="color: #707070; font-size: 14px; letter-spacing: -0.3px;">
                {{ product.talk_cnt }}개의 글
              </span>
            </div>
            <v-card tile flat class="card-shadow pa-0 ma-0">
              <v-list class="pa-0 px-3" v-if="product.talks.length">
                <CommentListTile v-for="(talk, index) of product.talks" :key="index"
                                 :idx="talk.idx"
                                 :postIdx="talk.store_idx"
                                 :createdAt="talk.created_at"
                                 :updatedAt="talk.updated_at"
                                 :contents="talk.contents"
                                 :likeCnt="talk.like_cnt"
                                 :likes="talk.likes"
                                 :user="talk.user"
                                 :recommentCnt="talk.comment_cnt"
                                 :recomments="talk.comments"
                                 @like="likeTalk"
                                 @comment="comment"
                                 @report="report"
                                 @remove="removeTalk"
                                 @moreRecomment="selectMore" />
              </v-list>
              <div v-else class="caption text-xs-center pb-4" style="color:#707070;">크리에이터에게 전하고 싶은 말이나,<br>함께 준비하는 사람들에게 보내는 응원의 말을 올려주세요!</div>
              <div class="d-flex pa-3" style="background-color: #f8f8f8;">
                <v-text-field class="border-radius-custom"
                              solo flat hide-details
                              append-icon="게시"
                              placeholder="한마디"
                              v-model="talk"
                              ref="talk"
                              @focus="checkUser"
                              @click:append="submitTalk"
                              @keyup.enter="submitTalk">
                </v-text-field>
              </div>
              <div class="d-flex pa-3">
                <v-btn class="more-button-style" block flat @click="$router.push({ name: 'ReadProductTalks', params: { idx, type: 'product' } })">
                  Let's Talk 더보기
                  <v-icon size="16px" class="ml-2">$vuetify.icons.arrowRight</v-icon>
                </v-btn>
              </div>
            </v-card>
          </v-container>
        </v-card>
      </v-flex>

      <v-flex xs12 v-show="!loading">
        <v-card tile flat class="mt-2">
          <v-card-title><h2>연관 클래스</h2></v-card-title>
          <v-card-text class="ma-0 pt-3 px-0 pb-4">
            <div class="store-swiper-container swiper-container"
                 style="padding: 0 16px 32px;">
              <div class="store-swiper-wrapper swiper-wrapper">
                <div class="store-swiper-slide swiper-slide"
                     v-for="(recommend, index) of product.recommends" :key="index">
                  <ProductCard :idx="recommend.idx"
                               :title="recommend.title"
                               :subtitle="recommend.subtitle"
                               :publishedAt="recommend.published_at"
                               :status="recommend.status"
                               :thumbnail="recommend.thumbnail"
                               :bookmarks="recommend.bookmarks"
                               :subtitle_color="recommend.subtitle_color"
                               @bookmark="bookmarkProduct(recommend.idx)" />
                </div>
              </div>
            </div>
          </v-card-text>

          <v-card-title><h2>환불 약정</h2></v-card-title>
          <v-card-text>
            <v-btn color="#f8f8f8" round depressed href="https://www.notion.so/glorang/f60a2fe3f6c14163a91cadf3571e0e4a" target="_blank">
              <span>서비스 이용/환불/환급 규정 보기</span>
              <v-icon size="16px">$vuetify.icons.arrowRight</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>

        <v-footer height="auto" color="#4a4a4a" dark class="footer-style">
          <v-container class="text-xs-left">
            <h1 class="pb-3">유스</h1>
            <v-layout justify-space-between align-center class="pt-3">
              <div style="font-size: 18px; font-weight: 700; letter-spacing: -0.5px; color: white;">크리에이터</div>
              <div>
                <v-btn small outline round class="ma-0 mr-2" color="#9b9b9b"
                       style="min-width: 70px; font-size: 14px; font-weight: 700; letter-spacing: -0.2px; color: #9b9b9b;"
                       target="_blank" href="https://www.youthcreator.me/">지원하기</v-btn>
                <v-btn small outline round class="ma-0" color="#9b9b9b"
                       style="min-width: 70px; font-size: 14px; font-weight: 700; letter-spacing: -0.2px; color: #9b9b9b;"
                       target="_blank" href="https://www.youthcreator.me/about-1">도움말</v-btn>
              </div>
            </v-layout>
            <v-layout justify-space-between align-center class="py-3">
              <div style="font-size: 18px; font-weight: 700; letter-spacing: -0.5px; color: white;">고객센터</div>
              <div>
                <v-btn small outline round class="ma-0" color="#9b9b9b"
                       style="min-width: 70px; font-size: 14px; font-weight: 700; letter-spacing: -0.2px; color: #9b9b9b;"
                       @click="inquiry">문의하기</v-btn>
              </div>
            </v-layout>
            <v-layout class="mb-2 pt-4" style="font-size: 12px; font-weight: 700; letter-spacing: -0.3px; color: #9b9b9b;">
              <span @click="$router.push({ name: 'TermsOfService' })">이용약관</span>ㅣ
              <span @click="$router.push({ name: 'PrivacyPolicy' })">개인정보처리방침</span>
            </v-layout>
            <v-layout class="text-xs-justify">
              <span style="font-size: 10px; color: #9b9b9b;">사업자 정보: {{ remarkText }}</span>
            </v-layout>
          </v-container>
        </v-footer>
      </v-flex>

      <v-footer fixed app height="74px" class="px-3" style="background-color: white;" v-show="!loading">
        <v-layout row align-center>
          <v-btn icon small class="my-0 ml-1 mr-3" @click="bookmarkProduct(product.idx)">
            <v-icon :color="product.bookmarks ? 'primary' : ''">{{ product.bookmarks ? '$vuetify.icons.heartFilled' : '$vuetify.icons.heartOutlined' }}</v-icon>
          </v-btn>
          <v-btn icon small class="my-0 ml-0 mr-3" @click="$vuetify.goTo('#Talk', tabScrollOptions)">
            <v-icon>$vuetify.icons.commentOutlined</v-icon>
          </v-btn>
          <v-divider vertical style="height: 16px; margin: auto;"></v-divider>

          <template v-if="product.category_idx === 2">
            <v-btn block large outline color="primary" class="purchase-button my-0 ml-3 mr-0" @click="openKakaoChatWithPixel">상담하기</v-btn>
          </template>

          <template v-else-if="product.status === 'ready'">
            <v-btn block large :outline="!product.alarms" :dark="product.alarms" color="primary" style="box-shadow: none;"
                   class="purchase-button my-0 ml-3 mr-0" @click="alarm">제작 알림 신청{{ product.alarms ? '중' : '' }}</v-btn>
          </template>

          <template v-else-if="product.purchases">
            <v-btn block large outline color="primary" class="purchase-button my-0 ml-3 mr-0"
                   href="https://www.youth.lol/app/store" target="_blank">
              앱에서 수강하기
            </v-btn>
          </template>

          <template v-else>
            <v-btn block large outline color="primary" class="purchase-button my-0 ml-3 mr-0" @click="purchase">구매하기</v-btn>
          </template>

        </v-layout>
      </v-footer>

      <!-- 환불 정책 다이얼로그 -->
      <v-dialog v-model="dialog" scrollable>
        <v-card>
          <v-toolbar flat dense>
            <v-btn small icon @click="dialog = false">
              <v-icon small>$vuetify.icons.cancel</v-icon>
            </v-btn>
            <h3 class="display-2" style="margin-bottom: 2px">{{ refundTerm.title }}</h3>
          </v-toolbar>

          <v-card-text style="height: 300px;" v-html="refundTerm.content"></v-card-text>
        </v-card>
      </v-dialog>

    </v-layout>
  </v-container>
</template>

<script>
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';
  // import videojs from 'video.js';
  import 'video.js/dist/video-js.css';
  import VideoPlayer from '@/components/VideoPlayer';

  import ProductCard from '@/components/ProductCard';
  // import ChannelListTile from '@/components/ChannelListTile';
  import CommentListTile from '@/components/CommentListTile';
  import ReviewListTile from "@/components/ReviewListTile";

  import terms from '@/assets/js/terms';

  import { intToCommaString, copyLink } from "@/util/util";
  import { mapGetters, mapActions, mapMutations } from 'vuex';

  export default {
    name: 'VideoClass',
    props: [ 'idx', 'loading' ],
    components: { VideoPlayer, ReviewListTile, ProductCard, CommentListTile },
    computed: {
      ...mapGetters('product', [ 'product' ]),
      ...mapGetters('user', { userIdx: 'idx' }),
      productTitle () {
        return this.loading ? '' : this.product.title;
      },
      playerOptions () {
        return {
          // language: 'ko',
          // autoplay: false,
          // muted: false,
          // playbackRates: [0.5, 1.0, 1.5, 2.0],
          sources: [{ src: `${this.$storage}/video/preview/${this.product.preview}`, type: 'video/mp4'}],
          poster: this.thumbnailSrc,
          hls: {
            overrideNative: true
          },
          html5: {
            nativeAudioTracks: false,
            nativeTextTracks: false
          },
        };
      },
      origin () {
        return window.location.origin;
      },
      thumbnailSrc () {
        return this.product.thumbnail && this.isImageLoaded ? `${this.$storage}/store/${this.product.thumbnail}` : require('@/assets/img/thumbnail-default.png');
      },
      finalPrice () {
        return this.product.discount > 0 ? Math.floor(this.product.amount * (100 - this.product.discount) / 100) : this.product.amount;
      },
      refundTerm () {
        return terms.refund;
      },
      lectureCount () {
        let total = 0;
        this.product.chapters.forEach(el => {
          total += el.lectures.length;
        });
        return total;
      }
    },
    data () {
      return {
        player: null,
        tooltip: false,
        dialog: false,
        // loading: true,
        time: parseInt(new Date().getTime() / 1000),
        isImageLoaded: true,
        isScroll: false,
        activeTab: null,
        tabScrollOptions: {
          duration: 300,
          offset: 100,
          easing: 'easeInOutQuad',
        },
        swiper: null,
        talkPage: {
          current: 2,
          max: 2
        },
        talk: '',
        commentTo: -1,
        reviewPage: {
          current: 2,
          max: 2
        },
        remarkText: '(주)GLORANGㅣ대표 황태일ㅣ개인정보보호 책임자 황태일ㅣ서울특별시 강남구 역삼로 180 마루 180 1층ㅣ전화 02-6929-4070ㅣ사업자등록번호 596-81-00999ㅣ통신판매업신고: 2019-서울강남-01817ㅣ(주)글로랑은 통신판매중개자이며 통신판매의 당사자가 아닙니다. 따라서 (주)글로랑은 상품, 거래 정보 및 거래에 대하여 책임을 지지 않습니다.',
      };
    },
    mounted () {
      this.swiperInit();
      window.addEventListener('scroll', this.changeSectionByScroll);
    },
    updated () {
      if (this.swiper) this.swiper.update();
      else this.swiperInit();
    },
    beforeDestroy () {
      if (this.swiper) this.swiper.destroy();
    },
    destroyed () {
      window.removeEventListener('scroll', this.changeSectionByScroll);
    },
    watch: {
      talk (text) {
        if (text === '') this.commentTo = -1;
      },
    },
    methods: {
      ...mapMutations('product', {
        mutateToggleSubscription: 'TOGGLE_SUBSCRIPTION',
        mutateToggleBookmark: 'TOGGLE_BOOKMARK',
        mutateToggleAlarm: 'TOGGLE_ALARM'
      }),
      ...mapActions('product', [
        'selectProduct', 'toggleBookmark', 'createTalk', 'createComment', 'toggleLikeTalk', 'toggleLikeComment',
        'reportTalk', 'reportComment', 'deleteTalk', 'deleteComment', 'selectComments', 'toggleAlarm',
        'purchaseFreeProduct'
      ]),
      ...mapActions('channel', [ 'toggleSubscription' ]),
      ...mapMutations('home', { mutationToggleStoreBookmark: 'TOGGLE_STORE_BOOKMARK' }),
      openKakaoChatWithPixel () {
        window.open('https://pf.kakao.com/_ygxjIT/chat');
      },
      goBack () {
        // if (window.history.length < 2) {
        //   this.$router.push({ name: 'Home'});
        // } else {
        //   this.$router.go(-1);
        // }
        this.$router.go(-1);
      },
      playLecture (status, lectureIdx) {
        if (this.product.purchases) {
          this.$router.push({ name: 'Lecture', params: { idx: this.idx, lectureIdx } })
        } else {
          if (status === 'free') this.$router.push({ name: 'Lecture', params: { idx: this.idx, lectureIdx } });
          else {
            if (confirm('아직 구매하지 않은 강의입니다. 지금 구매 페이지로 이동할까요?')) this.purchase();
          }
        }
      },
      swiperInit () {
        let container = document.querySelector('.store-swiper-container');
        if (container) {
          this.swiper = new Swiper('.store-swiper-container', {
            direction: 'horizontal',
            slidesPerView: 2,
            spaceBetween: 10,
          });
        }
      },
      onScroll () {
        this.isScroll = window.scrollY > this.$refs.introHeader.$el.offsetHeight;
      },
      changeSectionByScroll () {
        if (!document.getElementById('Preview')) return;
        // 스크롤 -> 탭 전환
        const preview = document.getElementById('Preview').offsetTop;
        const talk = document.getElementById('Talk').offsetTop;
        if (window.scrollY < preview - 50) {
          this.activeTab = 'Introduce';
        } else if (window.scrollY >= preview - 50 && window.scrollY < talk - 50) {
          this.activeTab = 'Preview';
        } else {
          this.activeTab = 'Talk';
        }
      },
      // subscribe (idx) {
      //   if (this.userIdx === 0) {
      //     this.$router.replace({ name: 'SocialLogin', query: { redirect: this.$route.path }});
      //   } else {
      //     this.toggleSubscription(idx).then(response => {
      //       this.mutateToggleSubscription({ idx, flag: response.data });
      //     }).catch(err => {
      //       console.error(err);
      //     });
      //   }
      // },
      bookmarkProduct (idx) {
        if (this.userIdx === 0) {
          this.$router.replace({ name: 'SocialLogin', query: { redirect: this.$route.path }});
        } else {
          this.toggleBookmark(idx).then(response => {
            this.mutateToggleBookmark({idx, flag: response.data});
            this.mutationToggleStoreBookmark({idx, flag: response.data});
          }).catch(err => {
            console.error(err);
          });
        }
      },
      purchase () {
				const _isMobile = navigator.userAgent.indexOf('Mobi') > -1;
				if (!_isMobile) {
					alert('모바일에서만 이용가능한 서비스입니다.');
					return;
				}
				if (this.userIdx === 0) this.$router.replace({ name: 'SocialLogin', query: { redirect: this.$route.path }});
        else {
          if (this.product.amount === 0) { // 무료 상품인 경우
            this.purchaseFreeProduct({ userIdx: this.userIdx, storeIdx: this.product.idx }).then(response => {
              if (response.data) this.$router.push({ name: 'PaymentComplete', query: { status: '00' } });
              else {
                alert('오류가 발생했습니다. 잠시 후 다시 시도해보세요.');
                console.log(response);
              }
            }).catch(err => {
              alert('오류가 발생했습니다. 잠시 후 다시 시도해보세요.');
              console.error(err);
            });
          } else if (this.product.packages) { // 무료 상품이 아니고, 패키지가 있는 경우
            this.$router.push({ name: 'PurchasePackage',
              params: {
                idx: this.idx,
                product: {
                  seller_idx: this.product.user.idx,
                  published_at: this.product.published_at,
                  title: this.product.title,
                  thumbnail: this.product.thumbnail,
                  status: this.product.status,
                }
              }
            });
          } else { // 무료 상품이 아니고, 패키지도 없는 경우
            this.$router.push({ name: 'PurchasePayment',
              params: {
                idx: this.idx,
                product: {
                  seller_idx: this.product.user.idx,
                  published_at: this.product.published_at,
                  title: this.product.title,
                  thumbnail: this.product.thumbnail,
                  status: this.product.status,
                },
                item: {
                  title: this.product.title,
                  discount: this.product.discount,
                  amount: this.product.amount,
                  kit: 0,
                  installment: this.product.installment,
                }
              }
            });
          }
        }
      },
      alarm () {
        if (this.userIdx === 0) this.$router.replace({ name: 'SocialLogin', query: { redirect: this.$route.path }});
        else {
          this.toggleAlarm(this.idx).then(response => {
            this.mutateToggleAlarm(response.data);
          }).catch(err => {
            console.error(err);
          });
        }
      },
      checkUser () {
        if (this.userIdx === 0) this.$router.replace({ name: 'SocialLogin', query: { redirect: this.$route.path }});
      },
      submitTalk () {
        if (this.userIdx === 0) this.$router.replace({ name: 'SocialLogin', query: { redirect: this.$route.path }});
        if (this.talk === '') return false;
        if (this.commentTo > -1) {
          this.createComment({ storeIdx: this.idx, talkIdx: this.commentTo, content: this.talk }).then(() => {
            // this.$refs.talkListTiles.scrollIntoView(); // TODO: recomment 작성한 글위치로 스크롤
            this.talk = '';
            this.commentTo = -1;
          });
        } else {
          this.createTalk({ idx: this.idx, content: this.talk }).then(() => {
            this.$refs.talkListTiles.scrollIntoView();
            this.talk = '';
          });
        }
      },
      likeTalk (payload) {
        // console.log('likecomment', payload);
        if (typeof payload.commentIdx === 'undefined') {
          this.toggleLikeTalk({ storeIdx: payload.postIdx, talkIdx: payload.idx });
        } else {
          this.toggleLikeComment({ storeIdx: payload.postIdx, talkIdx: payload.commentIdx, commentIdx: payload.idx });
        }
      },
      comment (payload) {
        // console.log('recomment', payload);
        if (typeof payload.commentIdx === 'undefined') {
          this.talk = `@${payload.commentUserName} `;
          this.commentTo = payload.idx;
        } else {
          this.talk = `@${payload.commentUserName} `;
          this.commentTo = payload.commentIdx;
        }
        this.$refs.talk.focus();
      },
      report (payload) {
        // console.log('report', payload);
        if (typeof payload.commentIdx === 'undefined') {
          this.reportTalk({ storeIdx: payload.postIdx, talkIdx: payload.idx }).then(response => {
            // if (!response.data) this.showSnackbar('이미 신고한 댓글입니다.');
            // else this.showSnackbar('댓글이 신고되었습니다.');
            if (!response.data) alert('이미 신고한 댓글입니다.');
            else alert('댓글이 신고되었습니다.');
          }).catch(err => {
            console.error(err);
          });
        } else {
          this.reportComment({ storeIdx: payload.postIdx, talkIdx: payload.commentIdx, commentIdx: payload.idx }).then(response => {
            // if (!response.data) this.showSnackbar('이미 신고한 댓글입니다.');
            // else this.showSnackbar('댓글이 신고되었습니다.');
            if (!response.data) alert('이미 신고한 댓글입니다.');
            else alert('댓글이 신고되었습니다.');
          }).catch(err => {
            console.error(err);
          });
        }
      },
      removeTalk (payload) {
        // console.log('remove', payload);
        if (typeof payload.commentIdx === 'undefined') {
          this.deleteTalk({ storeIdx: payload.postIdx, talkIdx: payload.idx });
        } else {
          this.deleteComment({ storeIdx: payload.postIdx, talkIdx: payload.commentIdx, commentIdx: payload.idx });
        }
      },
      selectMore (payload) {
        if (payload.recommentOffset <= payload.recommentCnt) {
          this.selectComments({ second: this.time, storeIdx: this.idx, talkIdx: payload.commentIdx, page: payload.recommentOffset });
        }
      },
      inquiry () {
        if (this.userIdx === 0) this.$router.replace({ name: 'SocialLogin', query: { redirect: this.$route.path }});
        else {
          // eslint-disable-next-line
          Kakao.PlusFriend.chat({
            plusFriendId: '_ygxjIT'
          });
        }
      },
      addComma (int) {
        return intToCommaString(int);
      },
      share () {
        copyLink(window.location.href);
        // this.showSnackbar('링크가 복사되었습니다.');
        alert('링크가 복사되었습니다.');
      },
      onPlayerReady (player) {
        this.player = player;
      },
      onLoaded (player) {
        console.log('onLoaded', player);
        player.play();
      },
      onEnded (player) {
        console.log('onEnded', player);
      },
      onError (player) {
        console.log('onError: ', player);
      },
    }
  }
</script>

<style lang="scss" scoped>
  .channel-small-icon {
    flex-shrink: 0;

    width: 33px;
    /*height: 19px;*/
    line-height: 19px;
    border-radius: 8px;
    background-color: map_get($colors, charcoal);

    color: white;
    font-size: 10px;
  }

  .custom-chip {
    padding: 0 6px;
    line-height: 22px;
    background-color: map_get($colors, charcoal);
    border-radius: 5px;

    color: white;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: -0.2px;
  }

  .summary-text {
    padding-right: 20px;
    padding-left: 20px;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.3px;
    color: map_get($colors, charcoal);
  }

  /deep/.extension-padding .v-toolbar__extension {
    padding: 0;
  }

  .top-button {
    width: 24px;
    height: 24px;
    flex: 0 0 auto;
    &.v-btn--depressed {
      border-color: #cdcdcd !important;
    }
  }

  .top-right-radius {
    width: auto;
    border-top-right-radius: 40px;
    // box-shadow: 0 -8px 10px 0 rgba(black, 0.06);
  }

  .summary-more-gradient {
    position: absolute;
    top: 16px;
    left: 0;
    width: 100%;
    height: 120px;
    background-image: linear-gradient(to bottom, rgba(#f8f8f8, 0) 50%, rgba(#f8f8f8, 1) 100%);
  }

  .installment-tooltip {
    margin-left: 8px;
    width: 16px;
    height: 16px;
    text-align: center;
    line-height: 16px;
    font-size: 12px;
    font-weight: 700;
    color: white;
    border-radius: 50%;
    background-image: linear-gradient(to bottom, #818181, #4a4a4a);
  }

  .package {
    &-text {
      font-size: 14px;
      letter-spacing: -0.2px;
      color: map_get($colors, charcoal);
      line-height: 24px;
    }
    &-text-big {
      font-weight: 300;
      font-size: 24px;
      letter-spacing: -0.3px;
      color: map_get($colors, charcoal);
      line-height: 30px;
    }
  }

  .purchase-button {
    border-radius: 24px;
    background-color: white;
    margin-left: 16px;
    margin-right: 16px;

    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.3px;
  }

  /deep/ .v-tabs__container {
    align-items: center;
    justify-content: space-between;
    height: 40px;
  }

  /deep/.tab {
    & > a {
      padding-left: 0;
      padding-right: 0;
      color: map_get($colors, brown-crey);
      font-size: 16px;
      letter-spacing: -0.3px;
      &.v-tabs__item--active {
        color: map_get($colors, charcoal);
      }
    }
  }

  /deep/.card-shadow {
    box-shadow: 0 2px 3px map_get($colors, background-shadow);
  }

  .footer-style {
    color: white;
  }

  .display-4 {
    word-break: keep-all;
    word-wrap: break-word;
  }

  /deep/.expansion-panel-style {
    box-shadow: none;
    .v-expansion-panel__header {
      /*height: 100%;*/
      justify-content: center;
      background-image: linear-gradient(to bottom, white, #f8f8f8);
    }
    .v-expansion-panel__container--active {
      .v-expansion-panel__header {
        background-image: none;
      }
    }
    .v-expansion-panel__header__icon {
      width: 16px;
      height: 16px;
      i {
        vertical-align: baseline;
      }
      i:before {
        font-size: 16px;
      }
    }
  }

  .chapter-text {
    font-size: 16px;
    font-weight: 700;
    color: map_get($colors, primary) !important;
    letter-spacing: -0.3px;
    padding-bottom: 8px;

    word-break: keep-all;
    white-space: pre-wrap;
  }

  /deep/.list-padding .v-list__tile {
    padding-right: 6px;
    height: auto;
  }

  /deep/.border-radius-custom {
    overflow: hidden;
    border-radius: 21px !important;
    .v-input__slot {
      cursor: pointer !important;
      padding: 0 18px !important;
    }
    input {
      cursor: pointer !important;
    }
    .v-icon {
      color: map_get($colors, primary);
      font-size: 12px;
    }
  }

  /deep/ .package-more-holder {
    text-align: left;
    width: 100%;
    max-width: 360px;
    margin: auto;
    align-items: center;
    & > .text-wrapper {
      min-width: 280px;
    }
  }

  .lecture-title {
    white-space: pre-wrap;
    padding-left: 20px;
    &:before {
      content: '\2022';
      position: absolute;
      left: 20px;
    }
  }

  .more-button-style {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: -0.2px;
    color: #4a4a4a !important;
    text-transform: unset;
    height: 38px;
    border: 1px solid #cdcdcd !important;
    border-radius: 19px;
    background-color: #f8f8f8 !important;
  }

  ::v-deep.v-tooltip__content {
    background-color: transparent;
    box-shadow: none;
    padding: 0;
  }
</style>
